import React from "react";
import { Tabs, Tab, Divider, Box } from "@material-ui/core";
import LayoutService from "../../../shared/services/layoutService";
import { MatIconService } from "../../../shared/services/theme/matIconService";
import PageDynamicHeaderComponent from "../../../shared/components/page/pageDynamicHeaderComponent";
import MatThemeService from "../../../shared/services/theme/matThemeService";
import "./ftpFolderComponent.css";
import UploadFileToFTPComponent from "./upload-file/uploadFileToFTPComponent";
import InProgressFilesComponent from "./inprogress-files/inProgressFilesComponent";
import { AuthContext } from "../../../shared/store/authProvider";
import { SubscriptionArray } from "../../../shared/services/dataService";
import FTPFolderService from "./ftpFolderService";

class FTPFolderComponent extends React.Component {
    static contextType = AuthContext;
    oSubscriptions = new SubscriptionArray();
    STORE = FTPFolderService;
    state = {
        selectedTabIndex: 0,
    };
    tabIndexMap = new Map();


    componentDidMount() {
        this.tabIndexMap.set(0, { ref: null });
        this.tabIndexMap.set(1, { ref: null });
    }

    componentWillUnmount() {
        this.oSubscriptions.cancelAll();
    }
  

    onTabChange = (event, _newTabIndex) => {
        this.setState({
            showConfirmDialog: false,
            selectedTabIndex: _newTabIndex,
            isReadOnly: true // on tab change make it readonly   
        });
    };

    render() {
        const { classes } = this.props;
                return (
                    <div id="MainRoleGrid">
                        <div style={{ backgroundColor: "#ddd", textAlign: "right" }}></div>
                        {/* <div className="IconBg marginTop10px tableTitleHead"> */}
                        {/* Header Componenet */}
                        <PageDynamicHeaderComponent classes={classes} label="FTP Folders" rightPadding={16}
                            leftActions={[{ icon: MatIconService.BACK, title: "Back", iconColor: "secondary", onClick: this.props.history.goBack }]}
                        />
                        {/* </div> */}
                        <Tabs value={this.state.selectedTabIndex} onChange={this.onTabChange} indicatorColor="secondary" textColor="inherit" variant="scrollable" scrollButtons="auto"
                            style={{ backgroundColor: MatThemeService.getTabBG() }}>
                            <Tab label="Upload File" id="uploadFile" />
                            <Tab label="View InProgress Files" id="viewInProgressFiles" />
                        </Tabs>
                        <div role="tabpanel" hidden={this.state.selectedTabIndex !== 0} id={"uploadFileTabPanel"} >
                            <Divider />
                            <Box style={{ padding: "10px" }} >
                                <UploadFileToFTPComponent tabConfig={this.tabIndexMap.get(0)} isReadOnly={this.state.isReadOnly} history={this.props.history}
                                    onClose={() => { this.onClose(false); }} />
                            </Box>
                        </div>
                        <div role="tabpanel" hidden={this.state.selectedTabIndex !== 1} id={"viewFilesInProgressTabPanel"} >
                            <Divider />
                            <Box style={{ padding: "10px" }} >
                                <InProgressFilesComponent tabConfig={this.tabIndexMap.get(1)} isReadOnly={this.state.isReadOnly} history={this.props.history}
                                    onClose={() => { this.onClose(false); }} />
                            </Box>
                        </div>

                    </div>
                );
    }
}

export default LayoutService.getHocComponenet(FTPFolderComponent);
